import { cn } from "@/lib/utils";

import { ProvenanceBadge } from "./provenance-badge";

interface DemoLegendProps {
  className?: string;
}

/**
 * Non-interactive real-vs-mock data key. Explains what the `ProvenanceBadge`
 * pills sprinkled across the comms screens mean — it never filters or hides
 * anything, purely a legend.
 */
export function DemoLegend({ className }: DemoLegendProps) {
  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      <p className="text-muted text-[10px] font-medium tracking-[0.18em] uppercase">Demo legend</p>
      <div className="flex items-center gap-1.5">
        <ProvenanceBadge provenance="real" full />
        <ProvenanceBadge provenance="mock" full />
      </div>
    </div>
  );
}
